import { render } from "./Login.vue?vue&type=template&id=56b872cd"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=56b872cd&lang=css"

import exportComponent from "/Users/swdz/devPhp/hbx_code/chatWeb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__